import { type EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';

import { RecentsRepository } from '@efficiently/client-api-recents';

import { RecentsGqlRepository } from './repositories';

export function provideRecentsDataAccess(): EnvironmentProviders {
	return makeEnvironmentProviders([{ provide: RecentsRepository, useClass: RecentsGqlRepository }]);
}
